import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  .cse-video {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .cse-video--embed {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 0;
  }

  .play-button,
  video {
    grid-column: 1;
    grid-row: 1;
    margin: 0 auto;
  }

  .cse-video--embed iframe {
    grid-column: 1;
    grid-row: 1;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0;
    border: 0;
    display: block;
  }

  .play-button {
    z-index: 1;
    position: absolute;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
